<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    width="40%"
    class="exp-settings-modal"
    @close="beforeClose"
  >
    <el-row slot="title">
      <b>
        Настройки заказчика
        {{ client ? client.short_name : 'перевозки' }}
      </b>
    </el-row>
    <el-form
      v-if="!client"
      ref="clientForm"
      :model="formData"
      :rules="rules"
      label-position="top"
    >
      <el-row :gutter="24">
        <el-col :span="16">
          <el-form-item prop="inn">
            <el-input v-model="formData.inn" placeholder="Введите ИНН" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-button type="info" plain @click="checkINN">
            Проверить ИНН
          </el-button>
        </el-col>
      </el-row>
      <span v-if="ifInnError">
        ИНН указан не верно или более не существует
      </span>
      <span v-if="isINN">
        Результат проверки: <b>{{ isINN }}</b>
      </span>
    </el-form>
    <el-row v-if="client || isINN">
      <p>Описание:</p>

      <el-input v-model="fields.description" :rows="5" type="textarea" />
      <el-row style="margin-top: 12px">
        <el-radio v-model="require_szvm_insurance_docs" label="0">
          не требует СЗВМ
        </el-radio>
        <el-radio v-model="require_szvm_insurance_docs" label="1">
          требует СЗВМ
        </el-radio>
      </el-row>
      <el-row class="raw-btn ta-r">
        <el-button type="primary" :loading="loading" @click="onSave">
          Сохранить
        </el-button>
      </el-row>
    </el-row>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapActions, mapGetters } from 'vuex'

const Check = RepositoryFactory.get('check')

export default {
  name: 'ClientSettingsModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    client: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formData: { inn: '' },
      require_szvm_insurance_docs: '0',
      rules: {
        inn: { required: true, message: 'Введите ИНН', trigger: 'blur' },
      },
      fields: {
        description: '',
      },
      org_id: 0,
      isINN: '',
      ifInnError: false,
    }
  },
  computed: {
    ...mapGetters({ loading: 'clients/getLoading' }),
  },
  watch: {
    client: {
      immediate: true,
      handler(exp) {
        if (exp) {
          this.fields = { description: exp.description }
          this.require_szvm_insurance_docs = String(
            exp.require_szvm_insurance_docs,
          )
        }
      },
    },
  },
  methods: {
    checkINN() {
      this.$refs['clientForm'].validate(valid => {
        if (valid) {
          this.ifInnError = false
          this.isINN = ''
          Check.inn(this.formData.inn)
            .then(res => {
              if (!res.data) {
                this.ifInnError = true
              } else {
                this.isINN = res.data.short_name || 'Нет даннных'
                this.org_id = res.data.id
              }
            })
            .catch(err => this.errHandler(err))
        }
      })
    },
    ...mapActions({
      updateClient: 'clients/updateItem',
      createClient: 'clients/createItem',
    }),
    onSave() {
      const data = {
        description: this.fields.description,
        require_szvm_insurance_docs: this.require_szvm_insurance_docs,
      }

      this.client ? this.handleUpdate(data) : this.handleCreate(data)
    },
    handleUpdate(data) {
      this.updateClient({ id: this.client.id, data })
        .then(() => {
          this.$message.success('Настройки успешно сохранены')
          this.$emit('client-updated')
          this.beforeClose()
        })
        .catch(err => this.errHandler(err))
    },
    handleCreate(data) {
      this.createClient({ ...data, org_id: this.org_id })
        .then(() => {
          this.$message.success('Клиент успешно создан')
          this.beforeClose()
        })
        .catch(err => this.errHandler(err))
    },
    beforeClose() {
      this.$emit('close')
      this.isINN = ''
      this.ifInnError = false
      this.org_id = 0
      this.formData = { inn: '' }
      this.fields.description = ''
    },
  },
}
</script>

<style lang="sass">
.exp-settings-modal
  color: #000
  font-size: 14px
  .el-dialog__header
    padding-left: 50px
    font-size: 18px
  .el-dialog__body
    color: #000
    font-size: 14px
    padding: 10px 50px 30px
    p
      margin-top: 30px
    .raw-btn
      margin-top: 50px
      button
        width: 200px
        height: 45px
</style>
